import { Validators } from '../../../../../utils/validators';
import { FormModel } from '../../../../../components/Form';
export const AddEditLocationForm = (strings: any, width = 3): FormModel[] => {
  return [
    {
      label: strings.location_text_name,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: width === 3 ? 'name' : 'locationName',
      validators:
        width === 12
          ? []
          : [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 100 }],
      responsive: width === 12 ? { xs: 12 } : { xs: 12, sm: 6, md: 4, lg: 3 },
      required: width === 3,
    },
  ];
};
